'use client';

import SettingConfig from '@module/config/setting';
import './Visual.scss';

function Visual() {
  return (
    <>
      <section className='visual-container'>
        <div className='visual first'>
          <img src={`${SettingConfig.S3_BUCKET_URL}/img/law/main-img.png`} alt='' />
        </div>
        <div className='visual'>
          <img src={`${SettingConfig.S3_BUCKET_URL}/img/law/main-img2.png`} alt='' />
        </div>
        <div className='visual'>
          <img src={`${SettingConfig.S3_BUCKET_URL}/img/law/law-main-img03.png`} alt='' />
        </div>
      </section>
      <section id='intro'>
        <div className='mini-calendar'>
          <img src={`${SettingConfig.S3_BUCKET_URL}/img/law/mini-calendar.png`} alt='' />
          <button
            onClick={() => {
              const target = document.querySelector('.calender-container') as HTMLDivElement;
              window.scrollTo({
                top: target.offsetTop,
                behavior: 'smooth',
              });
            }}
          >
            일정 확인하기
          </button>
        </div>
        <div className='connect_intro'>
          <img src={`${SettingConfig.S3_BUCKET_URL}/img/law/counseling-img.png`} alt='' />
        </div>
      </section>
    </>
  );
}

export default Visual;
